export default __webpack_public_path__ + "4692b9ec53fd5972caa2f2372ae20d16.ttf";